/**
 * Modul Znalosti — sdílené konstanty a volání API.
 *
 * Barva je barva sekce Tým (jako Komunikace): v návrhu je modul fialový, aby
 * se odlišil od oranžových směn a tyrkysových volných směn.
 */
export const BARVA = '#B47AEA';
export const BARVA_SVETLA = '#831BE4';
export const BARVA_BG = 'rgba(180,122,234,0.12)';
export const BARVA_BORDER = 'rgba(180,122,234,0.45)';

export const barva = (isDark) => (isDark ? BARVA : BARVA_SVETLA);

export const TYPY = {
    jednobodovka: { label: 'Jednobodovka', zkratka: 'OPL' },
    navod: { label: 'Návod', zkratka: 'NÁVOD' },
};

export const STAVY = {
    koncept: 'Koncept',
    publikovano: 'Publikováno',
    archiv: 'Archiv',
};

export const TYPY_VAZEB = [
    { id: 'stranka', label: 'Obrazovka systému' },
    { id: 'typ_stroje', label: 'Typ stroje (všechny kusy)' },
    { id: 'zarizeni', label: 'Konkrétní kus zařízení' },
    { id: 'vozidlo', label: 'Auto' },
    { id: 'recept', label: 'Recept' },
    { id: 'pozice', label: 'Pozice' },
    { id: 'clanek', label: 'Související článek' },
];

export function hlavicky(json = true) {
    return {
        ...(json ? { 'Content-Type': 'application/json' } : null),
        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]')?.content,
        Accept: 'application/json',
    };
}

export async function api(url, { method = 'GET', body } = {}) {
    const res = await fetch(url, {
        method,
        headers: hlavicky(body !== undefined),
        body: body !== undefined ? JSON.stringify(body) : undefined,
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
        const prvni = data?.errors ? Object.values(data.errors)[0]?.[0] : null;
        throw new Error(prvni || data?.error || data?.message || 'Nepodařilo se');
    }
    return data;
}

/** Nahraje fotku nebo video do knihovny médií (složka `znalosti`) → `{id, url, nahled, typ}`. */
export async function nahrajMedium(soubor) {
    const fd = new FormData();
    fd.append('soubory[]', soubor);
    fd.append('slozka', 'znalosti');
    const res = await fetch('/api/media', { method: 'POST', headers: hlavicky(false), body: fd });
    const data = await res.json().catch(() => null);
    if (!res.ok || !Array.isArray(data) || !data[0]) {
        throw new Error(data?.message || (res.status === 413 ? 'Soubor je moc velký' : 'Nahrání se nepovedlo'));
    }
    const m = data[0];
    return { id: m.id, url: m.url, nahled: m.thumbnail_url || (m.typ === 'foto' ? m.url : null), typ: m.typ, delka_s: m.delka_s };
}

/** Délka videa „0:48". */
export function delka(s) {
    if (!s && s !== 0) return null;
    const n = Math.round(Number(s));
    return `${Math.floor(n / 60)}:${String(n % 60).padStart(2, '0')}`;
}

export const datum = (d) => (d ? new Date(d).toLocaleDateString('cs', { day: 'numeric', month: 'numeric', year: 'numeric' }) : '');

/**
 * Otevře článek odkudkoli (krok receptu, panel ?) — app.jsx naviguje na
 * modul Znalosti. Komponenty hluboko ve stromu `navigateTo` nemají.
 */
export function otevriZnalost(params) {
    window.dispatchEvent(new CustomEvent('znalosti-otevrit', { detail: params }));
}

/** Odkaz pro QR štítek — celá adresa, telefon ji otevře v PWA. */
export const qrOdkaz = (token) => `${window.location.origin}/#/znalosti?qr=${token}`;
